import { createGlobalStyle } from 'styled-components';
import { DefaultTheme } from './theme';
export const GlobalStyles = createGlobalStyle<{ theme: DefaultTheme }>`
  body {
    background: ${({ theme: { colors } }) => colors.background};
    color: ${({ theme: { colors } }) => colors.text};
    font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter";
  }
  input, textarea {font-family: inherit}
  button {cursor: pointer; font-family: inherit; color: ${({ theme: { colors } }) =>
    colors.text};} `;
